/* eslint import/prefer-default-export:0 */

export const APP_VIEW = {
	list: 'list',
	map: 'map',
	manager: 'manager'
};
